import React, { useState } from 'react';
import axios from 'axios';
import { baseAPI } from '../../config';
import { toast } from 'react-toastify';
import { BuildingOffice2Icon } from '@heroicons/react/24/outline';
import {
  COMPANY_PROFILE_FIELDS,
  COMPANY_PROFILE_FIELD_LABELS,
  COMPANY_SERVICE_TYPE_LABELS,
} from '@claimup/shared/constants/company';

// Campos largos → textarea; el resto → input simple.
const TEXTAREA_FIELDS = [
  'description',
  'debtor_profile',
  'frequent_disputes',
  'discount_policy',
  'payment_plan_policy',
];

const CompanyProfileManager = ({ userData }) => {
  const [profile, setProfile] = useState(() => {
    const p = userData?.company_profile || {};
    return COMPANY_PROFILE_FIELDS.reduce(
      (acc, field) => ({ ...acc, [field]: p[field] || '' }),
      {}
    );
  });
  const [isSaving, setIsSaving] = useState(false);

  const onChange = (field, value) => setProfile(prev => ({ ...prev, [field]: value }));

  const onSave = async e => {
    e.preventDefault();
    setIsSaving(true);
    try {
      await axios.post(`${baseAPI}/users/${userData._id}/company-profile`, profile, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      toast.success('Perfil de empresa guardado');
    } catch (err) {
      console.error(err);
      toast.error('Error al guardar el perfil de empresa');
    } finally {
      setIsSaving(false);
    }
  };

  const serviceTypeLabel = userData?.service_type
    ? COMPANY_SERVICE_TYPE_LABELS[userData.service_type] || userData.service_type
    : null;

  return (
    <div className='bg-white shadow-lg rounded-lg border border-gray-200 mt-6'>
      <header className='px-5 py-4 border-b border-gray-100 flex items-center justify-between'>
        <div className='flex items-center'>
          <BuildingOffice2Icon className='w-6 h-6 mr-2 text-gray-600' />
          <h2 className='font-semibold text-gray-800'>Perfil de empresa (IA)</h2>
        </div>
        {serviceTypeLabel && (
          <span className='inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-slate-100 text-slate-700'>
            {serviceTypeLabel}
          </span>
        )}
      </header>

      <div className='p-5'>
        <p className='text-sm text-gray-500 mb-4'>
          Esta información ayuda al asistente de IA a comunicarse en nombre de la
          empresa. El tipo de servicio lo configura ClaimUp.
        </p>

        <form onSubmit={onSave} className='space-y-4'>
          {COMPANY_PROFILE_FIELDS.map(field => (
            <div key={field}>
              <label
                className='block text-sm font-medium text-gray-700 mb-1'
                htmlFor={`company-profile-${field}`}
              >
                {COMPANY_PROFILE_FIELD_LABELS[field]}
              </label>
              {TEXTAREA_FIELDS.includes(field) ? (
                <textarea
                  id={`company-profile-${field}`}
                  rows={3}
                  className='w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white'
                  value={profile[field]}
                  onChange={e => onChange(field, e.target.value)}
                />
              ) : (
                <input
                  id={`company-profile-${field}`}
                  type='text'
                  className='w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white'
                  value={profile[field]}
                  onChange={e => onChange(field, e.target.value)}
                />
              )}
            </div>
          ))}

          <div className='flex justify-end'>
            <button
              type='submit'
              disabled={isSaving}
              className='px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-60'
            >
              {isSaving ? 'Guardando…' : 'Guardar perfil'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompanyProfileManager;
